import { render, staticRenderFns } from "./UserAside.vue?vue&type=template&id=b2f4e8b0"
import script from "./UserAside.vue?vue&type=script&lang=ts"
export * from "./UserAside.vue?vue&type=script&lang=ts"
import style0 from "./UserAside.vue?vue&type=style&index=0&id=b2f4e8b0&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppAvatar: require('/builds/project/wyffest/frontend/components/app/AppAvatar.vue').default,AppIcon: require('/builds/project/wyffest/frontend/components/app/AppIcon.vue').default,AppBtn: require('/builds/project/wyffest/frontend/components/app/AppBtn.vue').default,UserNav: require('/builds/project/wyffest/frontend/components/user/UserNav.vue').default})
